<div class="main">
    <div class="container">
        <div class="brand-name">
            <a href="https://www.zisson.com/zisson-socialboards/"><strong>Socialboards</strong></a>
        </div>

        <h1>
            <span translate>Oops...</span>
            <br />
            <span translate>Something went wrong</span>
        </h1>

        <p class="info-text" translate>Please try again or reload this page.</p>

        <div class="image"></div>
    </div>
</div>
